import firebase from "firebase/app";

import { Card, Icon, Popup } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import softDeleteDocument from "astrid-firestore/src/api/documents/softDeleteDocument";
import updateProductionTodo from "astrid-firestore/src/api/productions/todos/updateProductionTodo";

import Flex from "../../../../../components/Flex/Flex";
import { useProfile } from "../../../../authentication/state/profile";
import ImageAvatar from "../../../../ui/components/ImageAvatar/ImageAvatar";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";
import themeColors from "../../../../ui/constants/themeColors";
import useLoadingFunction from "../../../../ui/hooks/useLoadingFunction";

import ProductionTodoDropdown from "./ProductionTodoDropdown";

export default function ProductionTodoContent({ todo, setEdit }) {
	const { t } = useTranslation();
	const user = useProfile();

	const [onResolve, , resolveError] = useLoadingFunction((todo) =>
		updateProductionTodo(firebase, {
			todo,
			resolved: !todo.resolved,
			updatedBy: user,
		}),
	);

	const [onRemove, removeLoading, removeError] = useLoadingFunction((todo) =>
		softDeleteDocument(firebase, todo, user),
	);

	return (
		<Card.Content style={{ position: "relative" }}>
			<Flex style={{ opacity: todo.resolved ? 0.5 : 1 }}>
				<div>
					<div>{todo.text}</div>

					<div style={{ fontSize: 12, color: themeColors.GREY }}>
						<ImageAvatar
							src={todo.createdBy?.img}
							style={{ display: "inline", width: 15, height: 15, marginRight: 5 }}
						/>
						{todo.createdBy?.name}
					</div>
				</div>

				<Popup
					content={t("resolvedBy", "Resolved by {{user}}", { user: todo.updatedBy?.name })}
					disabled={!todo.resolved}
					position="left center"
					size="mini"
					trigger={
						<Icon
							name={todo.resolved ? "check circle outline" : "circle outline"}
							color={todo.resolved ? "green" : "grey"}
							style={{ cursor: "pointer", marginRight: !todo.resolved ? 44 : 0 }}
							onClick={() => onResolve(todo)}
						/>
					}
				/>
			</Flex>

			{!todo.resolved && (
				<ProductionTodoDropdown onRemove={() => onRemove(todo)} setEdit={setEdit} loading={removeLoading} />
			)}

			{(resolveError || removeError) && <ErrorMessage error={resolveError || removeError} />}
		</Card.Content>
	);
}
